import { render } from "./PomodoroStats.vue?vue&type=template&id=daca947c&scoped=true"
import script from "./PomodoroStats.vue?vue&type=script&lang=js"
export * from "./PomodoroStats.vue?vue&type=script&lang=js"

import "./PomodoroStats.vue?vue&type=style&index=0&id=daca947c&lang=less&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-daca947c"]])

export default __exports__